module.exports = "/_next/static/festival-fdw.a641ba102f61ae15256ff08a37a1a4fb.css";